import React from 'react';
import { UserNav } from './UserNav';
// import { useTheme } from '../contexts/ThemeContext';
import IconButton from '../components/IconButton';
import { Bars3Icon } from '@heroicons/react/24/solid';

export default function Header({ showIconsOnly, setShowIconsOnly, selectionName }) {
  // const { switchTheme } = useTheme();

  return (
    <header className="select-none">
      <nav className="mx-auto flex w-full border-b justify-between items-center h-[50px] bg-white" aria-label="Global">
        <div>
          <div className="flex text-xl tracking-wider">
            <IconButton
              variant="header"
              className="flex md:hidden items-center mr-[2px] h-full rounded-none px-3 md:px-4"
              Icon={Bars3Icon}
              onClick={() => setShowIconsOnly(!showIconsOnly)}
            />
            <h1 className='text-sm font-bold text-primary m-auto tracking-normal md:hidden'>{selectionName}</h1>
          </div>
          <h1 className='text-2xl font-bold text-primary m-2 hidden md:block'>{selectionName}</h1>
          </div>
        <div className='flex h-full gap-2'>
          {/* <Button variant="header" className="flex items-center mr-[2px] h-full rounded-none" onClick={() => {}}>
            <PaintBrushIcon className="h-4 w-4 text-muted-foreground" />
          </Button> */}
          {/* <Notifications /> */}
          <UserNav />
        </div>
      </nav>
    </header>
  );
}
